'use client';

import { Flex, freddyTheme, Radio } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { FacetValue as FacetValueType } from '@features/filter/types';

import { ReviewDescription } from './ReviewDescription';

const FacetValue = ({ value }: { value: FacetValueType }) => {
  const reviewRatingTranslations = useFreddyTranslations('reviewRating');
  const generateRatingAriaLabel =
    value.value === '0'
      ? value.displayName
      : reviewRatingTranslations.ariaLabelReviewCountPlural
          .replace('{value}', String(Number(value.value) * 2))
          .replace('{reviewCount}', value.count.toString());

  return (
    <Flex
      component='label'
      inline
      sx={{
        gap: freddyTheme.spacing[200],
        cursor: 'pointer',
        '& input[type="radio"]': {
          marginTop: freddyTheme.spacing[50]
        }
      }}
    >
      <Radio value={value.value} aria-label={generateRatingAriaLabel} />
      <ReviewDescription value={value.value} count={value.count} />
    </Flex>
  );
};

export { FacetValue };
